import { render, staticRenderFns } from "./forgetPwd.vue?vue&type=template&id=ef0b9778&scoped=true"
import script from "./forgetPwd.vue?vue&type=script&lang=ts"
export * from "./forgetPwd.vue?vue&type=script&lang=ts"
import style0 from "./forgetPwd.vue?vue&type=style&index=0&id=ef0b9778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0b9778",
  null
  
)

export default component.exports